import { render, staticRenderFns } from "./UserTickets.vue?vue&type=template&id=5dbd182a&scoped=true"
import script from "./UserTickets.vue?vue&type=script&lang=js"
export * from "./UserTickets.vue?vue&type=script&lang=js"
import style0 from "./UserTickets.vue?vue&type=style&index=0&id=5dbd182a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd182a",
  null
  
)

export default component.exports